<template>
  <div class="agrotechnical_scheme_dialog">
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      @close="close"
    >
      <bigScreenTitleBorder :title="'基本信息'"></bigScreenTitleBorder>
      <el-col :span="12">
        <el-form
          :model="ruleForm"
          inline
          ref="ruleForm"
          :rules="rules"
          label-width="130px"
          :disabled="isDetail"
        >
          <el-form-item label="标题:" prop="titile">
            <el-input
              class="textInput"
              v-model="ruleForm.titile"
              placeholder="请输入标题"
            ></el-input>
          </el-form-item>
          <el-form-item label="适用区域:" prop="qhdm">
            <el-cascader
              class="textInput"
              size="small"
              ref="areaSelect"
              v-model="ruleForm.qhdm"
              :options="areaOptions"
              :props="areaProps"
              @change="liandong"
              :show-all-levels="false"
              placeholder="请选择适用区域"
            >
            </el-cascader>
            <div v-show="areaText" class="area_select_model" @click="areaModelClick" :class="{active:!isDetail}">
              {{areaText}}
            </div>
          </el-form-item>
          <!-- <el-form-item label="种养类型:" prop="dicName">
            <el-autocomplete
              v-model="ruleForm.dicName"
              ref="plantTypeSel"
              :fetch-suggestions="querySearchAsync"
              placeholder="请输入内容"
              @select="handleSelect"
            ></el-autocomplete>
          </el-form-item> -->
          <el-form-item label="信息类型:" prop="typeDicNumber">
            <el-select
              v-model="ruleForm.typeDicNumber"
              ref="typeDicNumber"
              placeholder="请选择"
            >
              <el-option
                v-for="item in infoTypeList"
                :key="item.dicNumber"
                :label="item.dicName"
                :value="item.dicNumber"
              >
              </el-option>
            </el-select>

            <!-- <el-cascader
              class="textInput"
              size="small"
              v-model="ruleForm.typeDicNumber"
              :options="agrotechTypeOption"
              :props="agrotechProps"
              @change="agrotechChange"
              ref="typeDicNumber"
              :show-all-levels="false"
              placeholder="请选择农技类型"
            >
            </el-cascader>
            <div v-show="agrotechText" class="area_select_model" @click="agrotechModelClick" :class="{active:!isDetail}">
              {{agrotechText}}
            </div> -->
          </el-form-item>
          <el-form-item label="信息来源:" prop="articleSource">
            <el-input
              class="textInput"
              v-model="ruleForm.articleSource"
              placeholder="请输入信息来源"
            ></el-input>
          </el-form-item>
          <el-form-item label="发布时间:" prop="pulishTime">
            <!-- <el-date-picker
              v-model="publishTime"
              type="date"
              placeholder="选择日期">
            </el-date-picker> -->
            <el-date-picker
              size="small"
              v-model="ruleForm.pulishTime"
              type="date"
              :picker-options="pickerOptions"
              value-format="yyyyMMdd"
              placeholder="选择时间">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="发布人员:" prop="pulishName">
            <el-input
              class="textInput"
              v-model="ruleForm.pulishName"
              placeholder="请输入发布人员"
              disabled
            ></el-input>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :span="12">
        <div style="width:100%;text-align:center;padding-top:20px">
          <el-upload
            title="产品图标"
            style="display: inline-block"
            :class="{eom_mag_hide:hideFrontUpload}"
            :on-preview="handlePictureCardPreview"
            :disabled="isDetail"
            ref="upload1"
            :headers="importHeaders"
            :action="actionurl"
            :file-list="frontFileList"
            :on-change="handleFrontChange"
            :on-remove="handleFrontRemove"
            list-type="picture-card"
            accept=".jpg,.png,.pdf"
            :auto-upload="true">
            <!-- <i slot="default" class="icon-card icon-card-front"></i> -->
            <i class="el-icon-plus" style="font-size: 20px"></i>
            <div slot="tip" class="el-upload__tip">
              <p><span v-show="false" class="el-upload-span">*</span> 封面照片</p>
            </div>
          </el-upload>
          <div class="evaluate" v-show="dialogType!='add'">
            <div class="stat">
              <!-- <div>
                <img
                  src="../../../../static/img/consult.png"
                  alt=""
                />
              </div> -->
              <i class="el-icon-view"></i>&nbsp;
              浏览量：{{ ruleForm.viewCount }}
            </div>
            <div class="stat">
              <!-- <div>
                <img src="../../../../static/img/reply.png" alt="" />
              </div> -->
              <i class="el-icon-star-off"></i>&nbsp;
              收藏量：{{ ruleForm.collectionCount }}
            </div>
            <div class="stat">
              <!-- <div>
                <img src="../../../../static/img/reply.png" alt="" />
              </div> -->
              <i class="el-icon-share"></i>&nbsp;
              分享量：{{ ruleForm.shareCount }}
            </div>
          </div>
        </div>
      </el-col>
      <bigScreenTitleBorder :title="'主体内容'"></bigScreenTitleBorder>
      <div class="detail" id="detail" style="height:500px;">
        <text-editor ref="textEditor"></text-editor>
      </div>
      <el-upload
        class="upload-demo"
        :disabled="isDetail"
        :action="actionurl"
        :on-preview="handlePreview"
        :on-remove="handleRemove"
        :headers="importHeaders"
        multiple
        :limit="5"
        :on-exceed="handleExceed"
        :on-change="handlehange"
        :file-list="fileArrList"
        :before-upload='beforeUpload'
        accept=".pdf">
        <el-button size="small" type="primary" :disabled="isDetail">上传附件</el-button>
        <!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div> -->
      </el-upload>
      <div slot="footer" style="text-align: center" class="dialog-footer">
        <el-button size="small" type="primary" plain @click="close"
          >取消</el-button
        >
        <el-button size="small" v-show="isDetail" type="primary" @click="activeEdit">编辑</el-button>
        <el-button size="small" v-show="!isDetail" type="primary" @click="update">提交</el-button>
      </div>
    </el-dialog>
    <el-image
      v-show="false"
      ref="imagePreview"
      :src="previewUrl"
      :preview-src-list="previewList">
    </el-image>
  </div>
</template>
<script>
import Cookies from "js-cookie";
import textEditor from './textEditor.vue'
import API from "@/api/api_insurance/api_insurance";
import API_agrotechnical from "@/api/api_agrotechnical/api_agrotechnical";
import API_dic from "@/api/api_common";
import bigScreenTitleBorder from "@/components/headerTitle/bigScreenTitleBorder.vue"
export default {
  components:{
    bigScreenTitleBorder,
    textEditor,
  },
  data() {
    return {
      dialogVisible: false,
      dialogTitle: '',
      areaCode: Cookies.get('curAreaCode'),
      areaName: Cookies.get('curAreaName'),
      qhdm: Cookies.get('curAreaCode'),
      qhmc: Cookies.get('curAreaName'),
      userName: Cookies.get('name'),
      userId: Cookies.get('userId'),
      enterpriseDeptNumber: Cookies.get("enterpriseDeptNumber"),
      enterpriseNumber: Cookies.get("enterpriseNumber"),
      ruleForm: {
        titile: "",
        qhdm: "",
        typeDicNumber: "", // 信息类型
        articleSource: "", //信息来源
        pulishTime: "", //发布时间
        pulishName: Cookies.get('name'),
        converImgUrl: '',
        collectionCount: 0,
        viewCount: 0,
        shareCount: 0,
      },
      rules:{
        titile: [
          { required: true, message: "请输入标题", trigger: "blur" },
        ],
        articleSource: [
          { required: true, message: "请输入信息来源", trigger: "blur" },
        ],
        typeDicNumber: [
          { required: true, message: "请选择信息类型", trigger: "change" },
        ],
        pulishTime: [
          { required: true, message: "请选择发布时间", trigger: "blur" },
        ],
        qhdm: [
          { required: true, message: "请选择适用区域", trigger: "change" },
        ],
      },
      publishTime: '',
      frontFileList: [],
      infoTypeList: [
        {
          dicName:'政策法规',
          dicNumber:'10611001'
        },
        {
          dicName:'时事要闻',
          dicNumber:'10611002'
        },
        {
          dicName:'通知公告',
          dicNumber:'10611003'
        }
      ],
      selectedPlantDicNumber: '', // 种养类型模糊搜索下拉框选中数据
      msg: `<p data-we-empty-p="" style="text-align:center;"><b><font color="#c24f4a">测试标题</font></b></p><p data-we-empty-p="" style="line-height:2;">清明前后，种瓜点豆，农业农村部表示，春耕生产秩序已基本恢复正常，今年夏粮丰收有希望、有基础。不过，近期受疫情影响，不少国家开始限制粮食出口，有人担心粮食会短缺或者涨价，开始囤积粮食。这种做法有必要吗？我们通过权威数据为您分析。<br/></p><p data-we-empty-p="" style="">我国粮食已经连续五年稳定在1.3万亿斤以上，去年总产量13277亿斤，创历史最高水平。以14亿人口粗略计算，平均每人可以分到粮食948.36斤，远高于人均800斤的国际粮食安全标准线。<br/></p><p data-we-empty-p="" style="text-align:right;"><img src="http://ram-garo-socia-prod.oss-cn-zhangjiakou.aliyuncs.com/mobile/2022/06/08/567d38f818c94a5cb2f80c351e1c665c/15-%E6%89%B9%E5%8F%91%E8%AE%A2%E5%8D%95.png" style="max-width:100%;" contenteditable="false"/></p>`,
      banklist:[],
      dialogImageUrl:'',
      actionurl: process.env.baseMachineryServer + "/file/upload", //图片信息
      importHeaders:  {
      Authorization: Cookies.get("token"),
      // Appid: '75de62ff979e40b7ad933e426cbaf639',
      Appid: '64c0dba9d3dc4fd7b02a2e8f427930b1',
    },
      hideFrontUpload: false,
      hideBackUpload: false,
      isDetail: true,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      areaOptions: null,
      areaProps: {
        label: 'qhmc',
        value: 'qhdm',
        children: 'children',
        checkStrictly: true,
        lazy: true,
        lazyLoad (node, resolve) {
          setTimeout(() => {
            let nodes;
            console.log(1, node)
            if(node.children && node.children.length > 0){
              nodes = []
              resolve(nodes);
            }else{
              API_dic.getSysAreaSubarea({qhdm: node.value}).then(res=>{
                nodes = res.data
                // if(node.value.length==6){
                  nodes.forEach(item=>{
                    if(item.qhdm.length==9){
                      item.leaf = true
                    }
                  })
                // }
                resolve(nodes);
              })
            }
            // 通过调用resolve将子节点数据返回，通知组件数据加载完成
            // resolve(nodes);
          }, 300);
        }
      },
      agrotechProps: {
        label: 'dicName',
        value: 'dicNumber',
        children: 'children',
        checkStrictly: true,
        lazy: true,
        lazyLoad (node, resolve) {
          setTimeout(() => {
            let nodes;
            if(node.data.leaf){
              nodes = []
              resolve(nodes);
            }else{
              API_agrotechnical.getSubDicList({dicNumber: node.value}).then(res=>{
                nodes = res.data.list||[]
                // if(node.value.length==6){
                nodes.forEach(item=>{
                    item.leaf = true
                })
                // }
                resolve(nodes);
              })
            }
            // }
            // 通过调用resolve将子节点数据返回，通知组件数据加载完成
            // resolve(nodes);
          }, 300);
        }
      },
      previewList: [],
      previewUrl:'',
      dialogType: 'add',
      areaText: '',
      agrotechText: '',
      agrotechSubTypeNumber: '',
      agrotechSubTypeName: '',
      agrotechTypeNumber: '',
      agrotechTypeName:'',
      fileArrList:[]
    };
  },
  created() {
    // this.getUse();
    this.getNextXzqData();
    this.getAgrotechTypeList();
  },
  mounted(){
    // this.ruleForm.pulishName = this.userName;
    // 模拟 ajax 请求，异步渲染编辑器
    setTimeout(() => {
        this.html = '<p>模拟 Ajax 异步设置内容 HTML</p>'
    }, 1500)
  },
  methods: {
    onCreated(editor) {
        this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
    },
    async getAgrotechTypeList() {
      // let params = {
      //   category: "1061",
      // };
      // let { code, data } = await API_dic.getDicByCategory(params);
      // if (code == 0) {
      //   this.infoTypeList = data.list;
      // }
    },
    async querySearchAsync(queryString, cb){
      let result = [];
      if(queryString){
        let params = {
          dicName: queryString,
          categoryNumbers: ['1002','1028'],
        };
        let { code, data } = await API_agrotechnical.getDicList(params)
        if(code==0){
          result = data.list.map((item) => {
            return {
              value: item.dicName,
              name: item.dicNumber,
            };
          });
        }
      }
      cb(result);
    },
    handleSelect(item) {
      this.selectedPlantDicNumber = item.name;
    },
    show(row,type) {
      this.isDetail = type=='detail';
      this.dialogTitle = (type=='detail')? '详情' : '新增';
      this.dialogType = type;
      if(this.$refs.textEditor) {
        this.$refs.textEditor.seteditor();
      }
      if(row){
        this.getRecordDetail(row)
        this.articleFileListFun(row)
      }else{
        this.dialogVisible = true;
        this.hideFrontUpload = false;
      }
    },
    activeEdit(){
      this.isDetail = false;
      this.$refs.textEditor.editor.enable();
    },
    /*初始化行政区*/
    getNextXzqData(){
      let regionOption=localStorage.getItem("areaOptions");//获取乡级以上区域信息
      if (regionOption) {
        this.areaOptions = [{
          qhdm: this.areaCode,
          qhmc: this.areaName,
          children: null,
          leaf: this.areaCode.length>=9
        }]
      }else{
        this.areaOptions = null
      }
    },
    async getRecordDetail(row) {

      let params={
        number:row.number
      }
      let { code, data, msg } = await API_agrotechnical.getDetail(params);
      if (code == 0) {
        let article = data.article;
        article.pulishTime = article.pulishTime+'';
        this.ruleForm = {...article}
        this.areaText = this.ruleForm.qhmc;
         this.qhdm = this.ruleForm.qhdm;
         this.qhmc = this.ruleForm.qhmc;
        this.agrotechText = this.ruleForm.typeDicChildName?(this.ruleForm.typeDicName+'/'+this.ruleForm.typeDicChildName):this.ruleForm.typeDicName;
        if(article.converImgUrl){
          this.frontFileList=[{
            name: '封面图片',
            url: article.converImgUrl.split('?')[0],
          }]
          this.hideFrontUpload = true;
        }else{
          this.hideFrontUpload = false;
        }
        this.dialogVisible = true;
        setTimeout(()=>{
          this.$refs.textEditor.editor.txt.html(article.content)
          this.$refs.textEditor.editor.disable()
        },200)
      }else{
        this.$message.error(msg);
      }

      // let params={
      //   purposeRecordId:purposeRecordId
      // }
      // let { code, data, msg } = await API.recordDetail(params);
      // if (code == 0) {
      //   this.ruleForm = data.insureCheckRecordBo.insurePurposeRecordVo;
      //   this.ruleForm.createTime = this.GLOBAL.timetoDate(this.ruleForm.createTime,'time')
      //   this.dialogVisible = true;
      // }else{
      //   this.$message.error(msg);
      // }
    },
   async articleFileListFun(row){
        let params={
        number:row.number,
        fileType:3
      }
      let {code, data, msg} = await API_agrotechnical.articleFileList(params)
      if(code==0){
        this.fileArrList=[]
      data.list.forEach(item=>{
        this.fileArrList.push({
          name: item.name,
          fileUrl:item.fileUrl
        })
      })
      }else{
        this.fileArrList =[]
      }
    },

    //银行
    async getUse() {
      let { code, data } = await API.getUseList();
      if (code == 0) {
        this.banklist = data.list;
      }
    },
    update(){
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          let params = {
            category: '2',
            categorySub: '1',
            titile: this.ruleForm.titile,
            qhdm: this.qhdm,
            qhmc: this.qhmc,
            typeDicNumber: this.ruleForm.typeDicNumber,
            typeDicName: this.$refs.typeDicNumber.selectedLabel,
            articleSource: this.ruleForm.articleSource,
            pulishTime: this.ruleForm.pulishTime,
            pulishName: this.ruleForm.pulishName,
            content: this.$refs.textEditor.editor.txt.html(),
            converImgUrl: this.ruleForm.converImgUrl,
            enterpriseDeptNumber: this.enterpriseDeptNumber,
            enterpriseNumber:this.enterpriseNumber,
            articleFileList:this.fileArrList,
          }

          let requrestName = ''
          let typeName =' '
          if(this.dialogType=='add'){
            requrestName = 'addItem'
            typeName = '发布'
          }else{
            requrestName = 'editItem'
            typeName = '修改'
            params.number = this.ruleForm.number;
          }

          this.$confirm("确定"+typeName+"该信息？", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }).then(() => {
            API_agrotechnical[requrestName](params).then(res=>{
              if(res.code==0){
                this.GLOBAL.success('操作成功！')
                this.GLOBAL.eventBus.$emit("agrotechnicalSchemeUpdated");
                this.close();
              }else{
                this.GLOBAL.warning(res.msg)
              }
            })
          })

        }else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    close() {
      this.$refs.ruleForm.resetFields();
      this.qhdm = this.areaCode;
      this.qhmc = this.areaName;
      this.selectedPlantDicNumber = "";
      this.ruleForm.titile = "";
      this.ruleForm.qhdm = "";
      this.areaText = "";
      this.agrotechText = "";
      this.agrotechTypeNumber = "";
      this.ruleForm.dicName = "";
      this.ruleForm.typeDicName = "";
      this.ruleForm.typeDicNumber = "";
      this.ruleForm.typeDicChildName = "";
      this.ruleForm.typeDicChildNumber = "";
      this.ruleForm.articleSource = "";
      this.ruleForm.pulishTime = "";
      this.ruleForm.collectionCount = 0;
      this.ruleForm.viewCount = 0;
      this.ruleForm.shareCount = 0;
      this.frontFileList=[];
      this.ruleForm.content='';
      //  this.$refs.textEditor.editor.enable();
      // this.$refs.textEditor.editor.txt.clear();
      this.$refs.textEditor.editor.destroy()
      this.$refs.textEditor.editor.null

      this.dialogVisible = false;
      this.hideFrontUpload = false;
      this.fileArrList=[]
    },
    //上传图片
    handlePictureCardPreview(file) {
      // this.dialogImageUrl = file.url;
      // let key = file.name || file.key;
      // let filename = key.substring(key.lastIndexOf(".") + 1, key.length);
      // if (filename.indexOf("pdf") == 0) {
      //   window.open(file.url);
      //   return;
      // }
      // this.dialogVisibleimg = true;

      this.previewUrl = file.url
      this.$set(this,'previewList',[file.url]);
      this.$refs.imagePreview.showViewer = true;
    },
    //主图事件
    handleFrontChange(res) {
      this.ruleForm.converImgUrl = "";
      this.hideFrontUpload = true;
      if (res.response) {
        this.hideFrontUpload = res.response.code === 0;
        if (res.response.code === 0) {
          this.hideFrontUpload = true;
          this.ruleForm.converImgUrl = res.response.data.filePath.split('?')[0];
          this.frontFileList.push({
            name: res.response.data.filePath,
            url: res.response.data.filePath,
          });
        } else {
          this.hideFrontUpload = false;
          this.ruleForm.converImgUrl = "";
          this.frontFileList = [];
        }
      }
    },
    //主图事件
    handleFrontRemove() {
      this.hideFrontUpload = false;
      this.ruleForm.converImgUrl = "";
      this.frontFileList = [];
    },
    liandong(obj){
      if(obj.length>0){
        this.qhdm = obj[obj.length - 1];
        this.qhmc = this.$refs.areaSelect.getCheckedNodes()[0].label;
        this.areaText = this.qhmc;
      }else{
        this.qhdm = this.areaCode;
        this.qhmc = this.areaName;
        this.areaText = '';
      }
    },
    agrotechChange(obj){
      if(obj.length==1){
        this.agrotechTypeNumber = obj[obj.length - 1];
        this.agrotechTypeName = this.$refs.typeDicNumber.getCheckedNodes()[0].label;
        this.agrotechSubTypeName = "";
        this.agrotechSubTypeNumber = "";
        this.agrotechText = this.$refs.typeDicNumber.getCheckedNodes()[0].label;
      }else if(obj.length==2){
        this.agrotechTypeNumber = this.$refs.typeDicNumber.getCheckedNodes()[0].path[0];
        this.agrotechTypeName = this.$refs.typeDicNumber.getCheckedNodes()[0].pathLabels[0];
        this.agrotechSubTypeName = this.$refs.typeDicNumber.getCheckedNodes()[0].pathLabels[1];
        this.agrotechSubTypeNumber = this.$refs.typeDicNumber.getCheckedNodes()[0].path[1];
        this.agrotechText = this.agrotechTypeName+'/'+this.agrotechSubTypeName;
      }else{
        this.agrotechTypeNumber = '';
        this.agrotechTypeName = '';
        this.agrotechSubTypeName = '';
        this.agrotechSubTypeNumber = '';
        this.agrotechText = '';
      }
    },
    areaModelClick(){
      this.$refs.areaSelect.toggleDropDownVisible();
    },
    agrotechModelClick(){
      this.$refs.typeDicNumber.toggleDropDownVisible();
    },
    handlehange(res){
      if(res.response){
        if(res.response.code==0){
            this.fileArrList.push({
            name: res.name,
            fileUrl: res.response.data.filePath,})
        }else{
          this.fileArrList = []
        }

      }
    },
    handleRemove(file, fileList) {

          let index = this.fileArrList.findIndex((ele) => {
          return ele.uid === file.uid;
          });
          //当查找失败返回
          if (index === -1) {
          return console.log('删除失败');
          }
          this.fileArrList.splice(index, 1);
    },
      handlePreview(file) {
        // if(this.isDetail==false){
          window.open(file.fileUrl, '_blank')
        // }

      },
      handleExceed(files, fileList) {
        this.$message.warning(`当前限制选择 5 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
      },
      beforeRemove(file, fileList) {
        // if (file.status === "success") {
        // return this.$confirm(`确认删除${file.name}吗`, "确认删除");
        // }
      },
      beforeUpload(file) {
        const fileSuffix = file.name.substring(file.name.lastIndexOf(".") + 1);
        const whiteList = ["pdf"];
        if (whiteList.indexOf(fileSuffix) === -1) {
          this.$message.warning("暂时只支持 pdf 格式", "error");
          return false;
        }
      },
  },
  computed: {
    windowWidth() {
      return document.body.clientWidth;
    },
  },
  beforeDestroy() {
    const editor = this.editor
    if (editor == null) return
    editor.destroy() // 组件销毁时，及时销毁编辑器
  }
};
</script>
<style lang="less">
.agrotechnical_scheme_dialog{
  .el-dialog{
    width: 960px;
    .el-dialog__body{
      padding-top: 10px;
      .el-form{
        margin-top: 16px;
        text-align: center;
      }
    }
    .area_select_model{
      position: absolute;
      background-color: #f5f7fa;
      border-radius: 4px;
      color: #c0c4cc;
      width: 260px;
      height: 30px;
      top: 6px;
      left: 4px;
      padding-left: 12px;
      box-sizing: border-box;
      line-height: 30px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      text-align: left;
      &.active{
        background-color: #fff;
        color: #606266;
      }
    }
  }
  .demo-image__preview .el-image-viewer__close {
    color: #0464f3 !important;
  }
  .textInput,
  .el-date-editor,
  .el-input {
    width: 300px !important;
  }
  .eom_mag_hide{
    height: 148px;
    width: 148px;
    overflow: hidden;
    vertical-align: bottom;
  }
  .eom_mag_hide .el-upload--picture-card {
    display: none;
  }
  .eom_mag_hlist .el-upload--picture-card {
    display: none;
  }
  /*作业照片外层容器样式修改*/
  .img-form-item .el-form-item__content {
    width: 100%;
  }
  .dialog-footer {
    text-align: center;
  }
  .eom_mag_hide .el-upload--picture-card {
    display: none;
  }
  .icon-card{
    display: block;
    background-size: 148px 100px;
    background-repeat: no-repeat;
    background-position: center;
    width: 148px;
    height: 100px;
    margin-top: 24px;
  }
  .icon-card-front{
    background-image: url("../../../../../static/img/card_front.png");
  }
  .icon-card-back{
    background-image: url("../../../../../static/img/card_back.png");
  }
  ::v-deep .el-upload-list__item {
    transition: none !important;
  }
  .evaluate {
    display: flex;
    margin-top: 20px;
    justify-content: space-around;
    padding: 0 20px;
    box-sizing: border-box;
    .stat {
      // width: 117px;
      height: 30px;
      line-height: 30px;
      margin-right: 20px;
      // background: #f1f3f5;
      border-radius: 16px;
      display: flex;
      align-items: center;
      font-size: 12px;
      div {
        width: 30%;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      i{
        font-size: 16px;
        color: #00955B;
      }
      // img {
      //   width: 16px;
      //   height: 16px;
      // }
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/studio/policyNews/policyNews/components/details.vue